import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";

function ProtectedRoute({ children }) {
  const { isLoggedIn } = useSelector(state => state.authInfo);

  return (
    _.isUndefined(isLoggedIn) ? <></> :
      !isLoggedIn ? <Navigate to={WEB_ROUTES.ACCOUNT} replace={true} /> : children
  );
}

export default ProtectedRoute;
